require([],
    function() {
        var isInactiveCommunity = document.querySelector("[data-is-inactive-community]");
        if (isInactiveCommunity) {
            if(window.NHS && window.NHS.Scripts && window.NHS.Scripts.Favorites) {
                const logParameterElement = document.querySelector('[data-log-parameters]');
                if(logParameterElement) {
                    const favorites = new window.NHS.Scripts.Favorites({
                        urlBase: '',
                        logInfo: JSON.parse(logParameterElement.innerHTML)
                    });
                    favorites.init();
                }
            }
            require(["showInactiveCommunityModule"]);
        }
    });

define("nhs/views/CommunityDetail/show", function(){});

